import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";
import {UseState}       from "@Common/react/use-state";
import {equalDeep}      from "@Common/utils/objects";

import {VoucherForm} from "./voucher-form/voucher-form";

export const EditPanel = ({voucher, next}) => cs(
    consumeContext("apis"),
    ["billingAccounts", ({apis}, next) => Load2({
        fetch: () => apis.next.billing.getBillingAccounts({
            idProgram: voucher.idProgram,
            idBranch: voucher.idBranch,
            idAgent: voucher.idAgent,
            idRegion: voucher.idRegion,
        }),
        next,
    })],
    ["form", ({billingAccounts}, next) => VoucherForm({
        voucher, 
        billingAccountsList: billingAccounts?.value,
        next
    })],
    ["initData", ({form}, next) => form.changed && UseState({
        initValue: defaultState({form}),
        next,
    })],
    ({form, initData}) => next({
        editable: {
            changed: form.changed,
            invalid: form.invalid,
            submit: form.submit,
        },
        hasChanges: () => !equalDeep(initData.value, form.changed),
        highlightChanges: () => {
            form.highlight();
        },
        renderContent: () => cs(
            () => (
                <div className="edit-panel-3to">
                    {form.render()}
                </div>
            ),
        ),
    })
);

const defaultState = ({form}) => { 
    return {
        billingAccount: form.changed.billingAccount,
        comments: "",
        date: form.changed.date,
        total: form.changed.total,
    };
};
